import { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'wouter';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export default function Waitlisted() {
  const { user, logout, isLoading } = useAuth();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (!isLoading && !user) navigate('/login');
    if (!isLoading && user?.status === 'active') navigate('/profile');
  }, [isLoading, user, navigate]);

  if (isLoading || !user) return null;

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full text-center space-y-6"
      >
        <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center">
          <span className="text-3xl">✨</span>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-900">
            You're on the list{user?.name ? `, ${user.name.split(' ')[0]}` : ''}
          </h1>
          <p className="text-gray-500 leading-relaxed">
            We're carefully onboarding members to make sure every person gets the
            attention they deserve. We'll email you at{' '}
            <span className="font-medium text-gray-700">{user?.email}</span> when
            your access is ready.
          </p>
        </div>

        <div className="rounded-xl border border-sky-100 bg-sky-50 px-6 py-4 text-sm text-sky-800 space-y-1 text-left">
          <p className="font-semibold">What happens next</p>
          <ul className="space-y-1 list-disc list-inside text-sky-700">
            <li>We review your registration</li>
            <li>You receive an access invitation by email</li>
            <li>Log back in to start your Eirvana journey</li>
          </ul>
        </div>

        <Button
          variant="outline"
          className="w-full"
          onClick={() => {
            logout();
            window.location.href = '/';
          }}
        >
          Sign out
        </Button>
      </motion.div>
    </div>
  );
}
